import { MoreVert } from '@mui/icons-material'
import { Box, SxProps } from '@mui/material'
import { useStore } from '@priolo/jon'
import { FunctionComponent } from 'react'
import chatSo from 'stores/copilot/chat'
import { Chat } from 'types/copilot/Chat'



interface Props {
}

const MessagesHistoryCmp: FunctionComponent<Props> = ({
}) => {

	// STORES
	useStore(chatSo);


	// HOOKS


	// HANDLERS

	const handleSelectChat = (id: string) => {
		chatSo.setCurrent(id);
	}
	const handleMoreClick = (e: React.MouseEvent, id: string) => {
		e.stopPropagation()
		console.log("MORE CLICK", id)
	}

	// RENDER
	const chats = chatSo.state.all
	const isSelected = (chat: Chat) => chatSo.state.currentThreadId === chat.threadId

	return (
		<Box sx={sxList}>
			{chats.map((chat) => (

				<Box key={chat.threadId} sx={[sxListItem, isSelected(chat) ? sxListItemSelected : {}] as SxProps}
					onClick={() => handleSelectChat(chat.threadId)}
				>
					<Box sx={sxChatTitle}>{chat.title}</Box>
					<MoreVert sx={sxMoreIcon} className="more-icon" fontSize="small" 
						onClick={(e) => handleMoreClick(e, chat.threadId)}
					/>
				</Box>

			))}
		</Box>
	)
}

export default MessagesHistoryCmp




const sxList: SxProps = {
	display: "flex",
	flexDirection: "column",
	gap: "2px",
}

const sxListItem: SxProps = {
	cursor: "pointer",
	borderRadius: "12px",
	fontSize: "0.9rem",
	fontWeight: 500,
	p: "7px 12px",
	mx: "3px",
	height: "34px",

	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",

	transition: "background-color 0.2s ease",
	"&:hover": {
		bgcolor: "background.up0",
		"& .more-icon": {
			display: "flex",
		},
	},
}

const sxListItemSelected: SxProps = {
	bgcolor: "background.up0",
}

const sxChatTitle: SxProps = {
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis",
	flex: 1,
	minWidth: 0,
}

const sxMoreIcon: SxProps = {
	display: "none",
	borderRadius: "50%",
	"&:hover": {
		bgcolor: "background.up0",

	},
}
